module.exports = __webpack_public_path__ + "static/media/juicios-ejecutivos.77911cae.png";